import { Component, OnChanges, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { setListType } from '../../visual/visual.actions';

@Component({
  selector: 'nns-header-list-type-selector',
  template: `
      <div flex="none" layout="row" layout-align="start center">
         <nns-button class="icon transparent nns-to-view-list"
           (click)="setListTypeList()"
           [icon]="listIconList"
           title="Show as list"
         ></nns-button>
         <nns-button class="icon transparent nns-to-view-plates"
           (click)="setListTypePlates()"
           [icon]="listIconPlates"
           title="Show as tiles"
         ></nns-button>
      </div>
  `,
  styles: [`
    :host nns-button {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }
    :host nns-button:hover{
      background-color: #F5F8FA;
    }

    :host-context(.nns-theme-night) nns-button:hover {
      background-color: #20252B;
    }
  `]
})

export class HeaderListTypeSelectorComponent implements OnChanges {
  @Input() public visual;

  listIconList = 'list';
  listIconPlates = 'plates';

  constructor(
    public _store: Store<IAppState>
  ) { }

  ngOnChanges(changes:any) {
    if (changes.visual) {
      const listType = changes.visual.currentValue.listType;
      const theme = changes.visual.currentValue.theme;
      if(listType == 'list') {
        this.listIconList = theme == 'day' ? 'list-color' : 'list';
        this.listIconPlates = theme == 'day' ? 'plates' : 'plates-color';
      } else if(listType == 'plates') {
        this.listIconList = theme == 'day' ? 'list' : 'list-color';
        this.listIconPlates = theme == 'day' ? 'plates-color' : 'plates';
      }
    }
  }

  setListTypeList() {
    this.selectViewType('list');
  }

  setListTypePlates() {
    this.selectViewType('plates');
  }

  selectViewType(type) {
    this._store.dispatch(setListType(type));
  }
}
